window.addEventListener('load', () => {
  // Main logic for gifts
  handleGift();

  // Remove orphan gift on cart update
  document.body.addEventListener("cartUpdated", handleGift, false);
});

async function handleGift() {
  const todayDate = new Date();

  window.gifts.forEach(async (gift) => {
    // If the date of the promotion does not match, we stop here
    if(Date.parse(gift.end_date) >= todayDate && Date.parse(gift.start_date) <= todayDate) {
      const cart = await getCartItems();
      const giftProduct = await getProduct(gift.gift_handle);
      const triggerProduct = await getProduct(gift.product_trigger);

      let giftFound = false;
      let productTriggerFound = false;
      let countPrice = 0;
      let countProductInCollection = 0;
  
      // Loop on cart items
      for (const item of cart.items) {
        // If the cart already contains the gift, we set the variable giftFound to true
        if (giftProduct != null && item.id === giftProduct.product.variants[0].id) {
          giftFound = true;
        }
  
        // If the cart contains the product trigger, we set the variable productTriggerFound to true
        if (triggerProduct != null && item.id === triggerProduct.product.variants[0].id) {
          productTriggerFound = true;
        }
  
        // Loop on the collections
        const collections = getCollectionsByProductHandle(item.handle);

        for (const collection of collections) {
          // If the collection is the same collection that triggers the promo
          if (collection === gift.collection) {
            let foundDiscountedPrice = false;
            
            // If VolumeBoost exists and there's a discount
            if (typeof window.hulkapps !== 'undefined') {
              // Start loader
              document.getElementById('MainContent').classList.add('is-loading');

              // Quick fix to wait for VolumeBoost to do its things
              await timeout(3000);

              if (typeof window.hulkapps.discounts !== 'undefined') {
                window.hulkapps.discounts.cart.items.forEach((hulkItem) => {
                  if (hulkItem.variant_id == item.variant_id) {
                    countPrice += Math.round(hulkItem.discounted_line_price * 100)
                    foundDiscountedPrice = true;
                  }
                });
              }
            }

            // If there's no discount on VolumeBoost
            if (!foundDiscountedPrice) {
              countPrice += item.final_line_price;
            }
            
            countProductInCollection += item.quantity;
          }
        }
      }
  
      // If the cart is eligible for promo
      if (countProductInCollection >= gift.number_trigger || countPrice >= gift.price_trigger || productTriggerFound) {
        // If gift is not in the cart
        if (!giftFound) {
          if (gift.gift_availability === "true") {
            const updates = {};
    
            if (gift.same_qty === "true") {
              updates[giftProduct.product.variants[0].id] = countProductInCollection; 
            } else {
              updates[giftProduct.product.variants[0].id] = gift.qty;
            }
            
            await fetch(`${routes.cart_update_url}.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ updates })
            });

            const giftKey = await getItemKeyByVariantID(giftProduct.product.variants[0].id);

            await fetch(`${routes.cart_change_url}.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                'id': giftKey,
                'quantity': updates[giftProduct.product.variants[0].id],
                'properties': { '_isGift': true }
              })
            });
            
            await updateCartDOM();
          }
        } else {
          // If the gift is in the cart but the availability is false, we remove it
          if (gift.gift_availability === "false") {
            const updates = {};
  
            updates[giftProduct.product.variants[0].id] = 0;
    
            await fetch(`${routes.cart_update_url}.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ updates })
            });

            await updateCartDOM();
          } else {
            // If the gift is in the cart and the availability is true, update the quantity
            const updates = {};
    
            if (gift.same_qty === "true") {
              updates[giftProduct.product.variants[0].id] = countProductInCollection; 
            } else {
              updates[giftProduct.product.variants[0].id] = gift.qty;
            }
            
            await fetch(`${routes.cart_update_url}.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ updates })
            });

            await updateCartDOM();
          }
        }
      } else {
        // If the cart is not eligible for promo
        // If the cart already has the gift, we remove it
        if (giftFound) {
          const updates = {};
  
          updates[giftProduct.product.variants[0].id] = 0;
  
          await fetch(`${routes.cart_update_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          });

          await updateCartDOM();
        }
      }

      // Stop loader
      document.getElementById('MainContent').classList.remove('is-loading');
    }
  });
}

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function getCollectionsByProductHandle(handle) {
  let collections = [];
  
  window.cartItemsCollections.forEach((item) => {
    if(item[handle]) {
      collections = item[handle].split(','); 
    }
  });

  return collections;
}

async function getProduct(handle) {
  if (!handle) {
    return null;
  }
  
  const response = await fetch(`/products/${handle}.json`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  return response.json();
}

async function getCartItems() {
  const response = await fetch(`${routes.cart_url}.js`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  return response.json();
}

async function updateCartDOM() {
  await fetch(`${routes.cart_url}`, {
    method: 'GET'
  })
  .then((response) => {
    return response.text();
  })
  .then((html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    document.querySelector('[id*="__cart-items"]').outerHTML = doc.querySelector('[id*="__cart-items"]').outerHTML;
    document.querySelector('[id*="__cart-footer"]').outerHTML = doc.querySelector('[id*="__cart-footer"]').outerHTML;
    document.getElementById('cart-icon-bubble').outerHTML = doc.getElementById('cart-icon-bubble').outerHTML;
  });
}

async function getItemKeyByVariantID(id) {
  const cart = await getCartItems();
  let key = null;

  cart.items.forEach((item) => {
    if (item.variant_id == id) {
      key = item.key;
    }
  });

  return key;
}